import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { Icon } from "@/elements-react/fix-icon";

export interface CartProductNotifyProps {
  text: string;
  type?: "error" | "warning" | "info" | "success";
  className?: string;
}

const iconMap = {
  error: "exclamation-octagon",
  warning: "exclamation-triangle",
  info: "info-circle",
  success: "check-circle",
};

const CartProductNotify: React.FC<CartProductNotifyProps> = ({ text, type = "error", className }) => {
  const { t } = useTranslation();
  const iconName = iconMap[type] || iconMap.error;

  return (
    <div className={classNames(styles.root, styles[type], className)} role="alert">
      <span className={styles.icon}>
        <Icon name={iconName} />
      </span>
      <span className={styles.text}>{text}</span>
    </div>
  );
};

export default CartProductNotify;
